module.exports = __webpack_public_path__ + "img/xcx1.1550a584.jpg";